import React, { Component } from 'react';
import _ from 'underscore';

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'schools',

      foodCats: _.uniq(this.props.foods.map(f=>f.category)),

      editSchool: null,
      editDays: '',

      schoolName: '',
      schoolHasCoffee: false,
      schoolMorningTea: false,
      days: [],
      classrooms: '',
      schoolPickup: '',

      restrictSchools: [],
      foodName: '',
      foodHealthy: false,
      foodPrice: 0,
      foodCat: '',

      showPromo: (this.props.promo && this.props.promo.enable) || false,
      promoText: (this.props.promo && this.props.promo.text) || '',      

      showPopup: (this.props.popup && this.props.popup.enable) || false,
      popupMessage: (this.props.popup && this.props.popup.message) || '',

      coffee: {
        name: '',
        sizes: [{
          name: '',
          price: 0
        }]
      }
    }

    this.allDays = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday'
    ]
  }

  handleChange(e){
    var news = {};
    news[e.target.name] = e.target.value;
    this.setState(news);
  }

  handleCheck(e){
    var news = {};
    news[e.target.name] = e.target.checked;
    this.setState(news);
  }

  handleRestrictSchools(e){
    var rest = this.state.restrictSchools,
      val = parseInt(e.target.value, 10);
    e.target.checked ?
      rest.push(val) :
      rest = rest.filter(id=>id !== val)
    this.setState({restrictSchools: rest});
  }

  setTab(tab, e){
    e.preventDefault();
    this.setState({tab: tab});
  }

  removeSchool(id, e){
    e.preventDefault();

    alert('Please contact sam to remove schools')
    // var ok = window.confirm('Are you sure you want to delete this school?')
    // if(!ok) return;
    //
    // //Delete request
    // fetch('/api/schools/remove', {
    //   method: 'POST', // or 'PUT'
    //   body: JSON.stringify({id: id}),
    //   credentials: 'include',
    //   headers: new Headers({
    //     'Content-Type': 'application/json'
    //   })
    // })
    // .then(res => {
    //   if(res.ok){
    //     var schools = this.props.schools;
    //     schools = schools.filter(s=>s.id !== id);
    //     this.props.setState({schools: schools});
    //   }
    //   else
    //     throw new Error('Network response was not ok.');
    // })
  }

  removeFood(id, e){
    e.preventDefault();

    var ok = window.confirm('Are you sure you want to delete this food?')
    if(!ok) return;

    //Delete request
    fetch('/api/foods/remove', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({id: id}),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => {
      if(res.ok){
        var foods = this.props.foods;
        foods = foods.filter(f=>f.id !== id);
        this.props.setState({foods: foods});
      }
      else
        throw new Error('Network response was not ok.');
    })
  }

  removeCoffee(id, e){
    e.preventDefault();

    var ok = window.confirm('Are you sure you want to delete this coffee?')
    if(!ok) return;

    //Delete request
    fetch('/api/coffees/remove', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({id: id}),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => {
      if(res.ok){
        var coffees = this.props.coffees;
        coffees = coffees.filter(f=>f.id !== id);
        this.props.setState({coffees: coffees});
      }
      else
        throw new Error('Network response was not ok.');
    })
  }

  saveHolidays(e){
    // console.log(111, this.state.popupMessage)
    e.preventDefault()
    fetch('/api/holidays', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({
        showPopup: this.state.showPopup,
        popupMessage: this.state.popupMessage,
        showPromo: this.state.showPromo,
        promoText: this.state.promoText
      }),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => {
      if(res.ok){
        alert('Updated popup message')
      }
      else
        alert('Error updating popup message')
    })
  }

  newSchool(e){
    e.preventDefault();
    console.log('new school', this.state.schoolName, this.state.schoolHasCoffee);
    //Do post

    var school = {
      name: this.state.schoolName,
      coffee: this.state.schoolHasCoffee,
      morningTea: this.state.schoolMorningTea,
      days: this.state.days.map(day=>day.toLowerCase()).join(','),
      classrooms: this.state.classrooms.split("\n").map(room=>({
        name: room
      })),
      pickup: this.state.schoolPickup
    };

    fetch('/api/schools', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(school),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => {
      if(res.ok)
        return res.json()
      else
        throw new Error('Network response was not ok.');
    })
    .then(res => {
      if(res.error)
        this.setState({error: res.error})
      else {
        var schools = this.props.schools;
        schools.push(res);
        this.props.setState({
          schools: schools
        });
        this.setState({
          schoolName: '',
          schoolHasCoffee: false,
          classrooms: '',
          days: [],
          pickup: ''
        });
      }
    })
    .catch(error=> {
      console.log('error', error);
      this.setState({error: error.toString()})
    });
  }

  newFood(e){
    e.preventDefault();
    console.log('new food', this.state.foodName, this.state.foodHealthy, this.state.foodRestrict);
    //Do post
    var food = {
      name: this.state.foodName,
      healthy: this.state.foodHealthy,
      price: this.state.foodPrice,
      category: this.state.foodCat,
      schools: this.state.restrictSchools.length ? this.state.restrictSchools : null,
      days: this.state.days.map(day=>day.toLowerCase()).join(',')
    };

    fetch('/api/foods', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(food),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => {
      if(res.ok)
        return res.json()
      else
        throw new Error('Network response was not ok.');
    })
    .then(res => {
      if(res.error)
        this.setState({error: res.error})
      else {
        var foods = this.props.foods;
        foods.push(res);

        this.props.setState({
          foods: foods
        });

        this.setState({
          foodName: '',
          foodHealthy: false,
          restrictSchools: [],
          days: []
        });
      }
    })
    .catch(error=> {
      console.log('error', error);
      this.setState({error: error.toString()})
    });
  }

  newCoffee(e){
    e.preventDefault();
    console.log(44, this.state.coffee)

    fetch('/api/coffees', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(this.state.coffee),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => {
      if(res.ok)
        return res.json()
      else
        throw new Error('Network response was not ok.');
    })
    .then(res => {
      if(res.error)
        this.setState({error: res.error})
      else {
        var coffees = this.props.coffees;
        coffees.push(res);

        this.props.setState({
          coffees: coffees
        });

        this.setState({
          coffee: {
            name: '',
            sizes: [{
              name: '',
              price: 0
            }]
          }
        });
      }
    })
    .catch(error=> {
      console.log('error', error);
      this.setState({error: error.toString()})
    });
  }

  handleSizeChange(i, e){
    var coffee = this.state.coffee;
    coffee.sizes[i][e.target.name] = e.target.value;
    this.setState({coffee: coffee});
  }

  handleCoffeeChange(e){
    var coffee = this.state.coffee;
    coffee[e.target.name] = e.target.value;
    this.setState({coffee: coffee});
  }

  addSize(e){
    e.preventDefault();
    var coffee = this.state.coffee;
    coffee.sizes.push({
      name: '',
      price: 0
    });
    this.setState({
      coffee: coffee
    });
  }

  getDayCheckbox(day){
    if(!this.state.days) return null;
    return (
      <div className="checkbox" key={day}>
        <label>
          <input type="checkbox"
            name={day}
            checked={this.state.days.indexOf(day) > -1}
            onChange={this.handleDayCheck.bind(this)}/> {day}
        </label>
      </div>
    )
  }

  handleDayCheck(e){
    var days = this.state.days,
      checked = e.target.checked,
      prevChecked = this.state.days.indexOf(e.target.name) > -1;
    if(checked && !prevChecked)
      days.push(e.target.name)
    else if(!checked && prevChecked)
      days = _.without(days, e.target.name)
    this.setState({
      days: days
    });
  }

  handleEdit(type, id, e){
    e.preventDefault()
    if(type==='school'){
      var school = this.props.schools.find(s=>s.id === id)
      this.setState({
        schoolName: school.name,
        schoolHasCoffee: school.coffee || false,
        schoolMorningTea: school.morningTea || false,
        editDays: school.days || '',
        schoolPickup: school.pickup,
        editSchool: id
      })
    }
  }

  handleSave(type, e){
    e.preventDefault()

    if(type !== 'school') return

    var school = {
      id: this.state.editSchool,
      name: this.state.schoolName,
      coffee: this.state.schoolHasCoffee,
      morningTea: this.state.schoolMorningTea,
      days: this.state.editDays.toLowerCase() || null,
      pickup: this.state.schoolPickup
    };

    fetch('/api/update_school', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(school),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => {
      if(res.ok)
        return res.json()
      else
        throw new Error('Network response was not ok.');
    })
    .then(res => {
      if(res.error)
        this.setState({error: res.error})
      else {

        var schools = this.props.schools,
          match = schools.find(s=>s.id === this.state.editSchool),
          index = schools.indexOf(match)
        schools.splice(index, 1, res)

        this.props.setState({
          schools: schools
        });
        this.setState({
          editSchool: null,
          schoolName: '',
          schoolHasCoffee: false,
          pickup: ''
        });
      }
    })
    .catch(error=> {
      console.log('error', error);
      this.setState({error: error.toString()})
    });


  }

  getSchoolsForm(){
    return (
      <div>
        <h2>Schools</h2>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Has Coffee</th>
              <th>Morning Tea</th>
              <th>Days</th>
              <th>Pickup Text</th>
              <th>Edit</th>
              {/*<th>Remove</th>*/}
            </tr>
          </thead>
          <tbody>
            { this.props.schools.map(
              school => (this.state.editSchool === school.id ? (
                <tr key={school.id}>
                  <td>{school.name}</td>
                  <td>
                    <input type="checkbox" name="schoolHasCoffee"
                      checked={this.state.schoolHasCoffee}
                      onChange={this.handleCheck.bind(this)} />
                  </td>
                  <td>
                    <input type="checkbox" name="schoolMorningTea"
                      checked={this.state.schoolMorningTea}
                      onChange={this.handleCheck.bind(this)} />
                  </td>
                  <td>
                    <input type="text"
                      name="editDays"
                      value={this.state.editDays}
                      onChange={this.handleChange.bind(this)} />
                  </td>
                  <td>
                    <textarea
                      style={{width: '100%'}}
                      name="schoolPickup"
                      value={this.state.schoolPickup}
                      onChange={this.handleChange.bind(this)}>
                    </textarea>
                  </td>
                  <td>
                    <a href=""
                      onClick={this.handleSave.bind(this, 'school')}
                      className="btn btn-small btn-primary">
                        Save
                    </a>
                  </td>
                </tr>
              ) : (
                <tr key={school.id}>
                  <td>{school.name}</td>
                  <td>{school.coffee ? 'Yes' : 'No'}</td>
                  <td>{school.morningTea ? 'Yes' : 'No'}</td>
                  <td>{school.days}</td>
                  <td>{school.pickup}</td>
                  <td>
                    <a href=""
                      onClick={this.handleEdit.bind(this, 'school', school.id)}
                      className="btn btn-small btn-default">
                        Edit
                    </a>
                  </td>
                </tr>
              ))
            ) }
          </tbody>
        </table>
        { this.state.editSchool ? null : (
          <div>
            <h2>Add new school</h2>
            <form className="form-horizontal" onSubmit={this.newSchool.bind(this)}>
              <div className="form-group">
                <label htmlFor="exampleInputEmail3" className="col-sm-2 control-label">School Name</label>
                <div className="col-sm-10">
                  <input type="text"
                    className="form-control"
                    id="exampleInputEmail3"
                    placeholder="School Name"
                    name="schoolName"
                    value={this.state.schoolName}
                    onChange={this.handleChange.bind(this)} />
                </div>
              </div>

              <div className="form-group">
                <div className="col-sm-offset-2 col-sm-10">
                  <div className="checkbox">
                    <label>
                      <input type="checkbox"
                        name="schoolHasCoffee"
                        checked={this.state.schoolHasCoffee}
                        onChange={this.handleCheck.bind(this)}/> Has Coffee
                    </label>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <div className="col-sm-offset-2 col-sm-10">
                  <div className="checkbox">
                    <label>
                      <input type="checkbox"
                        name="schoolMorningTea"
                        checked={this.state.schoolMorningTea}
                        onChange={this.handleCheck.bind(this)}/> Morning Tea
                    </label>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-2 control-label">Pickup info</label>
                <div className="col-sm-10">
                  <input type="text"
                    className="form-control"
                    placeholder="Pickup info"
                    name="schoolPickup"
                    value={this.state.schoolPickup}
                    onChange={this.handleChange.bind(this)} />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-2 control-label">Days</label>
                <div className="col-sm-10">
                  {this.allDays.map(this.getDayCheckbox.bind(this))}
                </div>
              </div>

              <div className="form-group">
                <div className="col-sm-offset-2 col-sm-10">
                  <button disabled={
                    this.state.schoolName.length < 1
                    // || this.state.classrooms.length < 1
                  } type="submit" className="btn btn-primary">Save</button>
                </div>
              </div>
            </form>
          </div>
        )}

      </div>
    );
  }

  getFoodForm(){
    return (
      <div>
        <h2>Food</h2>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Is Healthy</th>
              <th>Price</th>
              <th>Category</th>
              <th>Restrict to schools</th>
              <th>Days</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            { this.props.foods.map(food => (
              <tr key={food.id}>
                <td>{food.name}</td>
                <td>{food.healthy ? 'Yes' : 'No'}</td>
                <td>${food.price}</td>
                <td>{food.category}</td>
                <td>
                  {
                    food.schools === null || food.schools.length < 1 ?
                      'Unrestricted' :
                      food.schools.map(
                        id=>{
                          var school = this.props.schools.find(s=>s.id === id);
                          if(school)
                            return school.name;
                          else
                            return 'deleted';
                        }
                      ).join(', ')
                  }
                </td>
                <td>{food.days}</td>
                <td>
                  <a href=""
                  className="btn btn-sm btn-danger"
                  onClick={this.removeFood.bind(this, food.id)}>x</a>
                </td>
              </tr>
            )) }
          </tbody>
        </table>
        <h2>Add new food</h2>
        <form className="form-horizontal" onSubmit={this.newFood.bind(this)}>
          <div className="form-group">
            <label htmlFor="exampleInputEmail3" className="col-sm-2 control-label">Food Name</label>
            <div className="col-sm-10">
              <input type="text"
                className="form-control"
                id="exampleInputEmail3"
                placeholder="Food Name"
                name="foodName"
                value={this.state.foodName}
                onChange={this.handleChange.bind(this)} />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="exampleInputEmail4" className="col-sm-2 control-label">Price</label>
            <div className="col-sm-10">
              <div className="input-group">
              <span className="input-group-addon">$</span>
              <input type="text"
                className="form-control"
                id="exampleInputEmail4"
                placeholder="Food Name"
                name="foodPrice"
                value={this.state.foodPrice}
                onChange={this.handleChange.bind(this)} />
              </div>
            </div>
          </div>

          <div className="form-group">
            <label className="col-sm-2 control-label">Category</label>
            <div className="col-sm-10">
              <select name="foodCat" onChange={this.handleChange.bind(this)} className="form-control">
                <option>Buns</option>
                <option>Salads</option>
                <option>Sandwiches &amp; Wraps</option>
                <option>Savoury</option>
                <option>Snacks</option>
                <option>Drinks</option>
                <option>Water</option>
                <option>Sweets</option>
                <option>Specials</option>
                {/* { this.state.foodCats.map(cat => (
                  <option key={cat}>{cat}</option>
                )) } */}
              </select>
            </div>
          </div>

          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="checkbox">
                <label>
                  <input type="checkbox"
                    name="foodHealthy"
                    checked={this.state.foodHealthy}
                    onChange={this.handleCheck.bind(this)}/> Is Healthy
                </label>
              </div>
            </div>
          </div>

          <div className="form-group">
            <div className="col-sm-2">
              <label className="control-label">
                Restrict to school
              </label>
            </div>
            <div className="col-sm-10">
              <div className="checkbox">

                {this.props.schools.map(s=>(
                  <p key={s.id}><label><input type="checkbox"
                    checked={this.state.restrictSchools.indexOf(s.id) > -1}
                    value={s.id}
                    name="restrictSchools"
                    onChange={this.handleRestrictSchools.bind(this)}/> {s.name}</label></p>
                ))}

              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button disabled={
                this.state.foodName.length < 1
              } type="submit" className="btn btn-primary">Save</button>
            </div>
          </div>

          <div className="form-group">
            <label className="col-sm-2 control-label">Days</label>
            <div className="col-sm-10">
              {this.allDays.map(this.getDayCheckbox.bind(this))}
            </div>
          </div>

        </form>
      </div>
    );
  }

  getCoffeeForm(){
    return (
      <div>
        <h2>Coffee</h2>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Sizes</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            { this.props.coffees.map(coffee => (
              <tr key={coffee.id}>
                <td>{coffee.name}</td>
                <td>
                  { coffee.sizes.map(
                    size => (<p key={size.id}>
                      {size.name} - ${size.price}
                    </p>)
                  )}
                </td>
                <td>
                  <a href=""
                  className="btn btn-sm btn-danger"
                  onClick={this.removeCoffee.bind(this, coffee.id)}>x</a>
                </td>
              </tr>
            )) }
          </tbody>
        </table>
        <h2>Add new coffee</h2>
        <form className="form-horizontal" onSubmit={this.newCoffee.bind(this)}>
          <div className="form-group">
            <label htmlFor="coffeeName" className="col-sm-2 control-label">Coffee Name</label>
            <div className="col-sm-10">
              <input type="text"
                className="form-control"
                id="coffeeName"
                placeholder="Coffee Name"
                name="name"
                value={this.state.coffee.name}
                onChange={this.handleCoffeeChange.bind(this)} />
            </div>
          </div>
          <div className="form-group">
            <label className="col-sm-2 control-label">Sizes</label>
            <div className="col-sm-10">
              { this.state.coffee.sizes.map((size, i)=>(
                <div className="row" key={i}>
                  <div className="col-sm-6">
                    <input className="form-control"
                      type="text" name="name" value={size.name}
                      placeholder="Size Name"
                      onChange={this.handleSizeChange.bind(this, i)} />
                  </div>
                  <div className="col-sm-6">
                    <div className="input-group">
                      <span className="input-group-addon">$</span>
                      <input className="form-control" type="number"
                        placeholder="Price"
                        name="price" value={size.price}
                        onChange={this.handleSizeChange.bind(this, i)} />
                    </div>
                  </div>
                  { i === this.state.coffee.sizes.length-1 ? (
                    <div className="col-sm-12">
                      <button className="btn btn-default"
                        onClick={this.addSize.bind(this)}>Add Size</button>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button disabled={
                this.state.coffee.name.length < 1 ||
                this.state.coffee.sizes.some(s=>s.name.length < 1)
              } type="submit" className="btn btn-primary">Save</button>
            </div>
          </div>
        </form>
      </div>
    );
  }

  getHolidaysForm(){
    return (
      <div>
        <h2>Holidays</h2>

        <form className="form-horizontal" onSubmit={this.saveHolidays.bind(this)}>

          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="checkbox">
                <label>
                  <input type="checkbox"
                    name="showPopup"
                    checked={this.state.showPopup}
                    onChange={this.handleCheck.bind(this)}/> Show holiday popup
                </label>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="exampleInputEmail3" className="col-sm-2 control-label">Popup Message</label>
            <div className="col-sm-10">
              <textarea type="text"
                className="form-control"
                id="exampleInputEmail3"
                placeholder="Popup Message"
                name="popupMessage"
                rows="10"
                value={this.state.popupMessage}
                onChange={this.handleChange.bind(this)}></textarea>
            </div>
          </div>

          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="checkbox">
                <label>
                  <input type="checkbox"
                    name="showPromo"
                    checked={this.state.showPromo}
                    onChange={this.handleCheck.bind(this)}/> Show promo link
                </label>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="exampleInputEmailPromo" className="col-sm-2 control-label">Promo button text</label>
            <div className="col-sm-10">
              <textarea type="text"
                className="form-control"
                id="exampleInputEmailPromo"
                placeholder="Example: Cloverlea Promo"
                name="promoText"
                rows="10"
                value={this.state.promoText}
                onChange={this.handleChange.bind(this)}></textarea>
            </div>
          </div>

          <button className="btn btn-primary">Save</button>

        </form>

      </div>
    )
  }

  render() {
    return (
      <div className="container">
        <h1>Admin</h1>

        { this.state.error ?
          <div className="alert alert-danger">{this.state.error}</div>
         : null }

        <ul className="nav nav-tabs">
          <li role="presentation" className={this.state.tab === 'schools' ? "active" : ''}>
            <a href="" onClick={this.setTab.bind(this, 'schools')}>
              Schools
            </a>
          </li>
          <li role="presentation" className={this.state.tab === 'food' ? "active" : ''}>
            <a href="" onClick={this.setTab.bind(this, 'food')}>
              Foods
            </a>
          </li>
          <li role="presentation" className={this.state.tab === 'coffee' ? "active" : ''}>
            <a href="" onClick={this.setTab.bind(this, 'coffee')}>
              Coffee
            </a>
          </li>
          <li role="presentation" className={this.state.tab === 'holidays' ? "active" : ''}>
            <a href="" onClick={this.setTab.bind(this, 'holidays')}>
              Settings
            </a>
          </li>
        </ul>

        {this.state.tab === 'schools' ? this.getSchoolsForm() : null}
        {this.state.tab === 'food' ? this.getFoodForm() : null}
        {this.state.tab === 'coffee' ? this.getCoffeeForm() : null}
        {this.state.tab === 'holidays' ? this.getHolidaysForm() : null}

      </div>
    );
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/pages/Admin.js